export default __webpack_public_path__ + "static/media/project-schedule-btn.121a7079.svg";